import { useCallback, useEffect, useState } from 'react';
import isNull from 'lodash/isNull';

import { ModalSteps } from './constants';

export const useAddressWizard = (initialAddress) => {
  const [step, setStep] = useState(ModalSteps.SEARCH);
  const [address, setAddress] = useState(null);
  const [errors, setErrors] = useState(null);
  const [hasResponseError, setResponseError] = useState(false);

  useEffect(() => {
    if (initialAddress && isNull(address)) {
      setAddress(initialAddress);
      setStep(ModalSteps.DETAILS);
    } else if (isNull(initialAddress) && !isNull(address)) {
      setAddress(null);
    }
  }, [initialAddress, address]);

  const updateAddress = useCallback((field, value) => {
    setAddress(prev => ({
      ...prev,
      [field]: value
    }));
  }, []);

  const handleAddressSelect = useCallback(({ location }) => {
    setAddress({
      id: location?.id,
      address1: location?.street,
      address2: '',
      town: location?.locality,
      country: location?.country,
      postcode: location?.postalcode,
      label: null,
      region: location?.region,
      location: {
        latitude: location.latitude,
        longitude: location.longitude,
      }
    });
    setStep(ModalSteps.DETAILS);
  }, []);

  return {
    step,
    setStep,
    address,
    errors,
    setErrors,
    hasResponseError,
    setResponseError,
    updateAddress,
    handleAddressSelect,
  };
};
